import { mapState, mapGetters } from 'vuex';
import widgetEmptyState from '@/components/generics/widget-empty-state/widget-empty-state';
import applySortOrder from '@/components/pinning/pinboard-sort';
import pinboardWidgetItem from '@/components/pinning/pinboard-widget-item/pinboard-widget-item.vue';
import Contract from '@/models/contract';

export default {
  components: { pinboardWidgetItem, widgetEmptyState },
  computed: {
    ...mapState('market', ['sessionHistory']),
    ...mapGetters('pinning', ['getWidgetSort']),
    items() {
      const sort = this.getWidgetSort('session-history');
      // entries saved before marketId was recorded cannot be linked
      const items = this.sessionHistory
        .filter((i) => i.marketId)
        .map((i) => {
          const instance = new Contract(i);
          return {
            id: i.contractId,
            marketName: i.marketName,
            marketId: i.marketId,
            contractName: i.contractName,
            image: i.contractImageSmallUrl || i.contractImageUrl,
            price: instance.changePriceAsCents,
            priceAsCents: instance.lastTradePriceAsCents,
            hasLastTradePrice: instance.hasLastTradePrice,
            lastClosePrice: instance.lastClosePrice,
            tradeVolume: i.totalSharesTraded || i.totalTrades || 0,
            investmentSize: instance.investmentSizeAsCents,
          };
        });
      return applySortOrder(items, sort, 'session-history');
    },
  },
  methods: {
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id },
      };
    },
  },
};
